jQuery(document).ready(function($) {
  $('.mobile-toggle-menu').on('click', function() {
    $('body').toggleClass('shown-mobile-menu');
  });

  $('.close-mobile-menu').on('click', function() {
    $('body').removeClass('shown-mobile-menu');
  });

  $('body').on('click', function(e) {
    if ( $(this).hasClass('shown-mobile-menu') && ! $(e.target).is('.header-navigation, .header-navigation *, .mobile-toggle-menu, .mobile-toggle-menu *') ) {
      $('body').removeClass('shown-mobile-menu');
    }
  });

  $('.navigation__children-toggle').on('click', function() {
    if ($(window).width() < 768) {
      $(this).siblings('.navigation__tier-2-container').toggleClass("open");
    }
    });


  const target = document.getElementById("search-result-message");
    const parent = document.getElementById("wof_order_from_main_container");

    const observer = new MutationObserver(() => {
      const isVisible = window.getComputedStyle(target).display === "block";

        if (isVisible) {
            parent.classList.add("search-result");
              } else {
                  parent.classList.remove("search-result"); // optional
                    }
                    });

                    observer.observe(target, {
                      attributes: true,
                        attributeFilter: ["style", "class"]
                        });
  
});